export default __webpack_public_path__ + "static/media/MilkyNice-Clean.7d75c7ae.ttf";